import { atom } from 'jotai';

import { updateV2SocketData } from '../v2-helper';
import { createTableAccumulatorBunja } from './table-accumulator';

export type Pswaps = Record<string, Pswap> | null;

export interface Pswap {
  notionalMaxOrderAmount: string;
  notionalMaxPosition: string;
  takerFeeRate: string;
}

export const pswapsAtom = atom<Pswaps>(null);

export const subscribePswapsBunja = createTableAccumulatorBunja(
  'private/pswaps',
  (store) => (wsData) => store.set(pswapsAtom, (prev) => updateV2SocketData(prev || {}, wsData)),
);
